export const NEXT_API_PATH = '/next-api'
export const NEXT_API_URL = process.env.NEXT_PUBLIC_NEXT_API_URL ?? '/next-api'
